<template>
  <div>
    <div
      v-if="!showPrompt"
      class="content confirm-order"
      :class="{
        'h5-confirm-order': isH5,
        'pc-confirm-order': !isH5,
        'pad-app-h5-confirm-order': isMGAppInPad && isH5,
      }"
    >
      <!-- 已有订单 -->
      <p v-if="showReorder" class="unpaid-order-tips">
        您已下单该商品，可继续完成支付
      </p>
      <div class="order-top-wrap">
        <!-- 用户信息 -->
        <div class="user-info" v-show="user">
          <img
            class="avatar"
            :src="user.avatar + '?imageView2/0/w/100'"
            alt="头像"
          />
          <div class="info-wrap">
            <p class="name">{{ user.nickname }}</p>
            <p class="mobile">{{ user.mobile | filterTel }}</p>
          </div>
        </div>
        <!-- 商品信息 -->
        <div class="course-list">
          <div
            v-for="item in sub_order_list"
            :key="item.course_id"
            class="course-card"
          >
            <img
              class="cover"
              :src="
                handleImageUrl(item.goods_cover_url) + '?imageView2/0/w/300'
              "
              alt=""
            />
            <div class="course-info">
              <p class="course-title">
                {{ item.goods_title }}
              </p>
              <div class="other-info">
                <div class="price-wrap">
                  <!-- 实付金额 -->
                  <p class="real-price">
                    <span>￥</span>{{ item.real_price / 100 }}
                  </p>
                  <p
                    v-if="item.total_price !== item.real_price"
                    class="origin-price"
                  >
                    ￥{{ item.total_price / 100 }}
                  </p>
                </div>
                <!-- 有效期 -->
                <p class="validity-period">
                  有效期：<span v-if="item.validity_type === 2">
                    <span v-if="item.enrollment_days"
                      >随到随学{{ item.enrollment_days }}天</span
                    >
                    <span v-else
                      >{{
                        moment(item.course_start_time * 1000).format(
                          "YYYY.MM.DD HH:mm"
                        )
                      }}至{{
                        moment(item.course_end_time * 1000).format(
                          "YYYY.MM.DD HH:mm"
                        )
                      }}</span
                    >
                  </span>
                  <span v-else-if="item.validity_type === 3">永久有效</span>
                  <span v-else-if="item.validity_type === 1"
                    >至{{
                      moment(item.course_end_time * 1000).format(
                        "YYYY.MM.DD HH:mm:ss"
                      )
                    }}</span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="order-bottom-wrap">
        <ul class="order-info">
          <li class="order-total-price">
            <span class="module-title">课程总价</span>
            <p>
              <span class="normal-text"
                >共{{ sub_order_list.length }}个课程
              </span>
              <span class="order-origin-price">
                ¥{{ orderInfo.total_price / 100 }}</span
              >
            </p>
          </li>
          <!-- 联报|拼团 -->
          <li v-if="[3, 4].includes(orderInfo.activity_type)">
            <span class="module-title">促销活动</span>
            <p>
              <span v-if="orderInfo.activity_type === 3" class="normal-text"
                >课程联报，</span
              >
              <span v-if="orderInfo.activity_type === 4" class="normal-text"
                >拼团活动，</span
              >
              <span class="order-discount-price">-¥{{ discountPrice }}</span>
            </p>
          </li>
          <!-- 无待支付订单 -->
          <li v-if="showCoupon && !showReorder">
            <span class="module-title">优惠券抵扣</span>
            <p @click="openCouponDialog" style="cursor: pointer">
              <span v-if="!couponInfo.coupon_id" class="normal-text">{{
                orderInfo.activity_type === 3 ? "无优惠券可用" : "选择优惠券"
              }}</span>
              <span
                class="order-discount-price"
                v-else-if="couponInfo.coupon_type === 1"
                >-￥{{ couponInfo.amount / 100 }}</span
              >
              <span class="order-discount-price" v-else
                >{{ couponInfo.ratio / 10 }}折优惠</span
              >
              <i class="el-icon-arrow-right arrow-icon"></i>
            </p>
          </li>
          <li>
            <span class="module-title">应付金额</span>
            <p class="order-real-price">￥{{ payableAmount }}</p>
          </li>
          <li v-if="showReorder">
            <span class="module-title">交易单号：</span>
            <span class="normal-text">{{ orderInfo.order_no }}</span>
          </li>
          <li v-if="showReorder">
            <span class="module-title">交易状态：</span>
            <span class="normal-text">{{ stateList[orderInfo.state] }}</span>
          </li>
          <li v-if="showReorder">
            <span class="module-title">下单时间：</span>
            <span class="normal-text">
              {{
                moment(orderInfo.created_at * 1000).format(
                  "YYYY.MM.DD HH:mm:ss"
                )
              }}</span
            >
          </li>
          <li v-if="orderInfo.remark">
            <span class="module-title">备注：</span>
            <span class="normal-text remark-test">{{ orderInfo.remark }} </span>
          </li>
        </ul>
      </div>

      <!-- 协议 -->
      <p v-if="!isH5" class="protocol-wrap">
        <el-checkbox v-model="checked"> </el-checkbox
        >点击支付按钮即表示您已阅读并同意
        <a href="javascript:;" @click="jumpPage('/service-agreement')"
          >《服务协议》</a
        >
      </p>

      <div class="fixed-bottom">
        <!-- 协议 -->
        <p v-if="isH5" class="protocol-wrap">
          <el-checkbox v-model="checked"> </el-checkbox
          >点击支付按钮即表示您已阅读并同意
          <a href="javascript:;" @click="jumpPage('/service-agreement')"
            >《服务协议》</a
          >
        </p>
        <div class="btn-wrap">
          <button
            @click="reorderAgain"
            v-if="showReorder"
            class="reorder-again"
            v-preventReClick
            :disabled="loading"
          >
            重新下单
          </button>
          <!-- 立即支付 -->
          <button
            class="buy-btn"
            :class="{
              'is-disabled': orderInfo.state !== 1,
              'unpaid-btn': showReorder,
            }"
            @click="payOrder"
            :disabled="orderInfo.state !== 1"
            v-preventReClick
            v-html="buyBtnText"
          ></button>
        </div>
      </div>
    </div>
    <prompt-page v-else :msgInfo="promptMsg" :orderInfo="orderInfo" />
    <coupon-dialog ref="couponDialog" @selectCoupon="selectCoupon" />
    <div id="confirm-order-container"></div>
  </div>
</template>

<script>
import Vue from "vue";
import Confirm from "@saas/components/src/components/confirm-order/index";
Vue.use(Confirm);
import { cancelOrder } from "@saas/server-api/src/learning-center";
import { million } from "@saas/components/src/utils/utils";
import CouponDialog from "./components/CouponDialog";
import {
  PromptPage,
  isH5,
  handleImageUrl,
  isMGAppInPad,
} from "@saas/components/src";
import { ORDER_STATE } from "@saas/components/src/utils/constants.js";
import moment from "moment";
import {
  getOrder,
  getCourseInfo,
  checkOrder,
} from "@saas/server-api/src/product-details";
import { calPrice } from "@saas/server-api/src/joint-purchase/index";
import { mapGetters } from "vuex";
export default {
  data: function () {
    return {
      handleImageUrl,
      moment,
      checked: true,
      orderInfo: {},
      productInfo: {},
      stateList: ORDER_STATE,
      promptMsg: {},
      showPrompt: false,
      couponInfo: {},
      isH5: isH5(),
      million,
      sub_order_list: [],
      showReorder: false,
      loading: false,
      isMGAppInPad: true,
    };
  },
  mounted() {
    this.isMGAppInPad = isMGAppInPad();
  },
  methods: {
    inintData() {
      if (this.$route.query.history) {
        this.showReorder = true;
      } else {
        this.showReorder = false;
      }
      this.sub_order_list = [];
      this.apiGetOrder();
    },
    reorderAgain() {
      if (this.loading) return;
      this.loading = true;
      // 取消订单
      let params = {
        order_no: this.orderInfo.order_no,
      };
      cancelOrder(params)
        .then((res) => {
          if (res.code === 1) {
            // 重新下单---非确认订单页，携带用户之前操作
            this.apiCalPrice();
          } else {
            this.$message.error(res.message);
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    apiCalPrice() {
      let params = {
        compute: false,
      };
      let { activity_id, activity_type, goods_id } = this.$route.query;
      if (activity_type) {
        activity_type = Number(activity_type);
      }
      if (activity_id !== null) {
        activity_id = Number(activity_id);
      }
      if ([2, 4].includes(activity_type) && activity_id !== null) {
        params.goods_items = [
          {
            goods_id,
            activity_type,
            activity_id,
          },
        ];
      } else {
        // 普通
        params.goods_items = [
          {
            goods_id,
          },
        ];
        if (activity_type === 3) {
          params.goods_items = [
            {
              goods_id,
            },
          ];
        }
      }
      calPrice(params).then((res) => {
        if (res.code === 1) {
          let calPriceData = res.data;
          calPriceData.activity_type = params.goods_items[0]?.activity_type;
          calPriceData.goods_items = params.goods_items;
          let user = this.user;
          document.querySelector(".confirm-order").style.display = "none";
          this.$saasConfirmOrder(
            [],
            "confirm-order-container",
            calPriceData,
            user
          );
        } else if (res.code === 55005 && res.data?.order_no) {
          this.$chiralAutoMessage(`仍存在待支付订单`, 1500);
          setTimeout(() => {
            this.$router.replace({
              name: "ConfirmOrder",
              params: {
                order_no: res.data.order_no,
              },
              query: { ...this.$route.query },
            });
          }, 1500);
        } else {
          this.$message.error(res.message);
        }
        this.loading = false;
      });
    },
    jumpPage(url) {
      if (window.isElectron || this.isH5) {
        this.$router.push(url);
      } else {
        this.$router.push(url);
      }
    },
    selectCoupon(info) {
      this.couponInfo = { ...info };
      console.log(this.couponInfo);
    },
    openCouponDialog() {
      if (this.orderInfo.activity_type === 3) return false;
      let course_id = this.orderInfo.course_id;
      if (!course_id && this.orderInfo?.sub_order_list?.length) {
        course_id = this.orderInfo.sub_order_list[0].course_id;
      }
      this.$refs.couponDialog.openDialog(course_id);
    },
    apiGetOrder() {
      getOrder({ order_no: this.$route.params.order_no }).then((res) => {
        if (res.code === 1) {
          this.orderInfo = res.data || {};
          if (res.data) {
            let state = res.data.state;
            if (state === 1) {
              // 获取商品信息
              if (res.data.course_id) {
                this.apiGetCourseInfo(res.data.course_id, res.data);
              } else {
                this.sub_order_list = res.data.sub_order_list || [];
                // this.orderInfo.activity_type = 3; //联报
              }
            } else {
              this.promptMsg = {
                linkList: [
                  {
                    routeName: "Home",
                    name: "官网",
                  },
                  {
                    routeName: "Trade",
                    name: "交易订单",
                  },
                ],
              };
              if (state === 2) {
                this.promptMsg.type = "success";
                this.promptMsg.msg = "订单已完成，无法重复处理。";
              } else if (state === 3 || state === 4) {
                this.promptMsg.type = "error";
                this.promptMsg.msg = "订单已关闭，无法重复处理。";
              }
              this.showPrompt = true;
              this.$router.go(-1);
            }
          }
        } else if (res.code === 6666) {
          this.promptMsg = {
            type: "error",
            msg: "您访问的页面不存在。",
            linkList: [
              {
                routeName: "Home",
                name: "官网",
              },
              {
                routeName: "myCourse",
                name: "学习中心",
              },
            ],
          };
          this.showPrompt = true;
          this.$router.go(-1);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    apiGetCourseInfo(course_id, orderInfo) {
      let { real_price, total_price } = orderInfo;
      getCourseInfo({ course_id }).then((res) => {
        if (res.code === 1) {
          if (res.data) {
            // 计算课时数
            // this.productInfo = this.handleLessonNum(res.data || {});
            // 处理课程信息
            let {
              cover_url,
              course_name,
              validity_type,
              enrollment_days,
              course_end_time,
            } = res.data || {};
            this.sub_order_list.push({
              goods_cover_url: cover_url,
              goods_title: course_name,
              validity_type,
              enrollment_days,
              course_end_time,
              real_price,
              total_price,
            });
          }
        }
      });
    },
    handleLessonNum(data) {
      let lessonNum = 0;
      if (data.unit_list && data.unit_list.length) {
        data.unit_list.forEach((unit) => {
          if (unit.lesson_list && unit.lesson_list.length) {
            lessonNum += unit.lesson_list.length;
          }
        });
      }
      data.lessonNum = lessonNum;
      return data;
    },
    async payOrder() {
      if (this.checked) {
        // 是否使用优惠券
        if (this.couponInfo.coupon_id) {
          let params = {
            coupon_id: this.couponInfo.coupon_id,
            order_no: this.orderInfo.order_no,
          };
          let { code, message, data } = await checkOrder(params);
          if (code !== 1) {
            this.$message.error(message);
            return;
          }
        }
        let url = `/payment/${this.orderInfo.order_no}`;
        this.$router.replace(url);
      } else {
        this.$message.warning("请先阅读并同意服务协议");
      }
    },
  },
  filters: {
    //加密手机号
    filterTel(val) {
      if (val) {
        return val.substring(3, 0) + "****" + val.substring(7);
      }
    },
  },
  computed: {
    ...mapGetters(["user"]),
    showCoupon() {
      // 促销、团购、联报-隐藏
      return ![2, 3, 4].includes(this.orderInfo.activity_type);
    },
    discountPrice() {
      let { total_price, real_price } = this.orderInfo;
      return (total_price - real_price) / 100;
    },
    payableAmount() {
      let price = this.orderInfo.real_price / 100;
      if (this.couponInfo.coupon_id) {
        // 有优惠券
        if (this.couponInfo.coupon_type === 1) {
          price = (
            (this.orderInfo.real_price - this.couponInfo.amount) /
            100
          ).toFixed(2);
        } else {
          price = (
            (this.orderInfo.real_price * (this.couponInfo.ratio / 100)) /
            100
          ).toFixed(2);
        }
      }
      return price;
    },
    buyBtnText() {
      if (this.orderInfo.state == 1) {
        if (this.showReorder) {
          return `继续支付 <span>￥</span><span class="price">${this.payableAmount}</span>`;
        } else {
          return `立即支付 <span>￥</span><span class="price">${this.payableAmount}</span>`;
        }
      } else {
        return this.stateList[this.orderInfo.state];
      }
    },
  },
  components: {
    "prompt-page": PromptPage,
    "coupon-dialog": CouponDialog,
  },
  watch: {
    "$route.params.order_no": {
      immediate: true, // 组件创建时立即触发
      handler(newValue) {
        if (newValue) {
          this.inintData();
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.pad-app-h5-confirm-order {
  width: 375px !important;
  margin: 0 auto;
  .fixed-bottom {
    width: 375px !important;
  }
}
.pc-confirm-order {
  max-width: 800px;
  width: 100%;
  min-height: 100vh;
  padding-top: 30px;
  padding-bottom: 200px;
  .unpaid-order-tips {
    text-align: center;
    font-weight: 500;
    font-size: 18px;
    color: $saas-text-color;
    margin-bottom: 30px;
  }
  .order-top-wrap {
    border-radius: 24px 24px 0 0;
    background: #fff;
    padding: 16px 16px 0 16px;
    margin-bottom: 10px;
    // 用户信息
    .user-info {
      display: flex;
      padding: 16px;
      height: 83px;
      background: #fafafa;
      border-radius: 24px;
      margin-bottom: 24px;
      .avatar {
        width: 50px;
        height: 50px;
        border-radius: 16px;
        border: 1px solid #e2e2e2;
        margin-right: 12px;
        object-fit: cover;
      }
      .info-wrap {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .name {
        font-weight: 500;
        font-size: 18px;
        color: #000000;
        line-height: 25px;
      }
      .mobile {
        font-size: 14px;
        color: #515350;
        line-height: 20px;
      }
    }
    // 商品信息
    .course-card {
      &:last-child {
        border-bottom: none;
        padding-bottom: 24px;
      }
      display: flex;
      padding-bottom: 12px;
      border-bottom: 1px solid #efefef;
      .cover {
        width: 140px;
        height: 78px;
        border-radius: 5px;
        margin-right: 12px;
        object-fit: cover;
      }
      .course-info {
        flex: 1;
        width: 0;
      }
      .course-title {
        width: 100%;
        font-weight: 500;
        font-size: 18px;
        color: $saas-text-color;
        line-height: 25px;
        padding-top: 4px;
        padding-bottom: 16px;
        word-break: break-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .other-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .price-wrap {
        display: flex;
        align-items: center;
      }
      .real-price {
        font-weight: 600;
        font-size: 20px;
        color: #f03349;
        line-height: 28px;
        span {
          font-size: 12px;
        }
        margin-right: 12px;
      }
      .origin-price {
        font-size: 16px;
        color: #747573;
        line-height: 22px;
        text-decoration: line-through;
      }
      .validity-period {
        font-size: 14px;
        color: #747573;
        line-height: 20px;
      }
    }
  }

  .order-bottom-wrap {
    padding: 0 20px 10px;
    margin-bottom: 10px;
    background: #fff;
    .order-info {
      li {
        display: flex;
        justify-content: space-between;
        padding: 15px 0;
      }
      .module-title {
        font-size: 16px;
        color: #515350;
        line-height: 22px;
      }
      .normal-text {
        font-size: 16px;
        color: $saas-text-color;
        line-height: 22px;
      }
      .remark-test {
        max-width: 400px;
        line-break: anywhere;
      }
      .order-origin-price {
        font-weight: 600;
        font-size: 16px;
        color: $saas-text-color;
        line-height: 22px;
      }
      .arrow-icon {
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
      }
      .order-discount-price {
        font-weight: 600;
        font-size: 16px;
        color: #f03349;
        line-height: 22px;
      }
      .order-real-price {
        font-weight: 600;
        font-size: 16px;
        color: #f03349;
        line-height: 22px;
      }
      .order-total-price {
        padding: 25px 0;
        margin-bottom: 9px;
        border-bottom: 1px solid #efefef;
      }
    }
  }
  .protocol-wrap {
    background: #fff;
    padding: 20px 20px 24px;
    border-radius: 0 0 24px 24px;
    font-size: 16px;
    color: #515350;
    line-height: 22px;
    ::v-deep .el-checkbox .el-checkbox__inner {
      position: relative;
      top: -1px;
      border-radius: 3px;
      margin-right: 5px;
      border-color: #e8e8e9;
    }
    ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      border-color: #fff;
    }
    a {
      margin-left: 8px;
      font-size: 16px;
      color: #00c89d;
      line-height: 22px;
    }
  }
  .fixed-bottom {
    z-index: 2;
    padding: 25px 20px;
    position: fixed;
    bottom: 0;
    width: 800px;
    height: 100px;
    background: #ffffff;
    box-shadow: 0px -6px 16px 0px rgba(102, 116, 107, 0.1);
    border-radius: 24px 24px 0px 0px;
    .buy-btn {
      width: 760px;
      height: 50px;
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      border-radius: 12px;
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      line-height: 22px;
    }
    .reorder-again {
      width: 350px;
      height: 50px;
      background: #f2f3f5;
      border-radius: 12px;
      font-weight: 400;
      font-size: 16px;
      color: $saas-text-color;
      line-height: 22px;
    }
    .unpaid-btn.buy-btn {
      width: 350px;
      height: 50px;
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      border-radius: 12px;
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      line-height: 22px;
    }
    .btn-wrap {
      display: flex;
      justify-content: space-between;
    }
  }
}

.h5-confirm-order {
  width: 100%;
  min-height: 100vh;
  padding-bottom: 4rem;
  padding-top: 0.33rem;
  background: #fff;
  .unpaid-order-tips {
    font-weight: 500;
    font-size: 0.37rem;
    color: $saas-text-color;
    line-height: 0.53rem;
    margin-bottom: 0.33rem;
    text-align: center;
  }
  .order-top-wrap {
    position: relative;
    &::after {
      position: absolute;
      left: 0;
      bottom: 0;
      display: flex;
      content: "";
      width: 100vw;
      height: 0.13rem;
      background: $saas-bg-color;
    }
    padding: 0 0.32rem 0.5rem;
    // 用户信息
    .user-info {
      display: flex;
      padding: 0.21rem 0.29rem;
      height: 1.49rem;
      background: #fafafa;
      border-radius: 0.32rem;
      margin-bottom: 0.4rem;
      .avatar {
        width: 1.07rem;
        height: 1.07rem;
        border-radius: 0.21rem;
        border: 0.03rem solid #e2e2e2;
        margin-right: 0.21rem;
        object-fit: cover;
      }
      .info-wrap {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .name {
        font-weight: 500;
        font-size: 0.43rem;
        color: #000000;
        line-height: 0.6rem;
      }
      .mobile {
        font-weight: 400;
        font-size: 0.32rem;
        color: #515350;
        line-height: 0.44rem;
      }
    }
    // 商品信息
    .course-card {
      &:last-child {
        padding-bottom: 0;
      }
      display: flex;
      padding-bottom: 0.4rem;
      .cover {
        width: 3.74rem;
        height: 2.08rem;
        border-radius: 0.13rem;
        margin-right: 0.2rem;
        object-fit: cover;
      }
      .course-info {
        flex: 1;
        width: 0;
        display: flex;
        flex-direction: column;
      }
      .course-title {
        width: 100%;
        font-weight: 500;
        font-size: 0.43rem;
        color: $saas-text-color;
        line-height: 0.6rem;
        padding-bottom: 0.13rem;
        word-break: break-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .other-info {
        flex: 1;
        display: flex;
        flex-direction: column-reverse;
        justify-content: space-between;
      }
      .price-wrap {
        display: flex;
        align-items: center;
      }
      .real-price {
        font-weight: 600;
        font-size: 0.45rem;
        color: #f03349;
        line-height: 0.64rem;
        span {
          font-size: 0.32rem;
        }
        margin-right: 0.27rem;
      }
      .origin-price {
        font-size: 0.32rem;
        color: #747573;
        line-height: 0.59rem;
        text-decoration: line-through;
      }
      .validity-period {
        font-size: 0.29rem;
        color: #747573;
        line-height: 0.4rem;
      }
    }
  }

  .order-bottom-wrap {
    padding: 0 0.4rem 0.4rem;
    .order-info {
      li {
        display: flex;
        justify-content: space-between;
        padding: 0.26rem 0;
      }
      .pd-top-0 {
        padding-top: 0;
      }
      .module-title {
        font-size: 0.4rem;
        color: #515350;
        line-height: 0.56rem;
      }
      .normal-text {
        font-size: 0.4rem;
        color: $saas-text-color;
        line-height: 0.56rem;
      }
      .remark-test {
        flex: 1;
        line-break: anywhere;
      }
      .order-origin-price {
        font-weight: 600;
        font-size: 0.4rem;
        color: $saas-text-color;
        line-height: 0.56rem;
      }
      .arrow-icon {
        font-weight: 600;
        font-size: 0.34rem;
        line-height: 0.56rem;
      }
      .order-discount-price {
        font-weight: 600;
        font-size: 0.4rem;
        color: #f03349;
        line-height: 0.56rem;
      }
      .order-real-price {
        font-weight: 600;
        font-size: 0.4rem;
        color: #f03349;
        line-height: 0.56rem;
      }
      .order-total-price {
        padding: 0.4rem 0;
        margin-bottom: 0.14rem;
        border-bottom: 0.01rem solid #efefef;
      }
    }
  }
  .fixed-bottom {
    z-index: 2;
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 2.8rem;
    box-shadow: 0rem -0.16rem 0.43rem 0rem rgba(102, 116, 107, 0.1);
    border-radius: 0.64rem 0.64rem 0rem 0rem;
    padding: 0 0.32rem 0.53rem;
    background: #fff;
    .protocol-wrap {
      padding: 0.27rem 0 0.27rem 0.13rem;
      font-size: 0.29rem;
      color: #515350;
      line-height: 0.4rem;
      ::v-deep .el-checkbox .el-checkbox__inner {
        border-radius: 0.08rem;
        margin-right: 0.13rem;
        border-color: #e8e8e9;
      }
      ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
        background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
        border-color: #fff;
      }
      a {
        margin-left: 0.07rem;
        font-size: 0.29rem;
        color: #00c89d;
        line-height: 0.4rem;
      }
    }
    .buy-btn {
      width: 9.36rem;
      height: 1.33rem;
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      border-radius: 0.32rem;
      font-weight: 500;
      font-size: 0.43rem;
      color: #ffffff;
      line-height: 0.6rem;
    }

    .reorder-again {
      width: 4.4rem;
      height: 1.33rem;
      background: #f2f3f5;
      border-radius: 0.32rem;
      font-weight: 500;
      font-size: 0.43rem;
      color: $saas-text-color;
      line-height: 0.6rem;
    }
    .unpaid-btn.buy-btn {
      width: 4.4rem;
      height: 1.33rem;
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      border-radius: 0.32rem;
      font-weight: 500;
      font-size: 0.43rem;
      color: #ffffff;
      line-height: 0.6rem;
    }
    .btn-wrap {
      display: flex;
      justify-content: space-between;
    }
  }
}

// button 禁用样式
.buy-btn.is-disabled:disabled {
  cursor: not-allowed; /* 更改鼠标指针为禁止符号 */
  opacity: 0.5; /* 降低不透明度以给予视觉提示 */
  pointer-events: none; /* 阻止点击事件 */
}
</style>
